import React, { useCallback, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { modals } from './index'

function AppModal() {
  const [props, setModalProps] = useState(null)
  const location = useLocation()
  const isOpen = props !== null

  const onClose = useCallback(() => {
    setModalProps(null)
  }, [setModalProps])

  useEffect(() => {
    const eventHandler = e => {
      if (e.detail.status === 'open') {
        setModalProps(e.detail)
      } else {
        setModalProps(null)
      }
    }

    document.addEventListener('@maui:modal-open', eventHandler)
    document.addEventListener('@maui:modal-close', eventHandler)

    return () => {
      document.removeEventListener('@maui:modal-open', eventHandler)
      document.removeEventListener('@maui:modal-close', eventHandler)
    }
  }, [setModalProps])

  // Whenever the location changes, close the modal
  useEffect(() => {
    onClose()
  }, [location, onClose])

  const Modal = modals[props?.type]

  if (!isOpen || !Modal) {
    return null
  }

  return (
    <Modal isOpen onClose={onClose} {...props} />
  )
}

AppModal.propTypes = {
  type: PropTypes.string,
  useMutation: PropTypes.func,
  useQuery: PropTypes.func
}

export default AppModal
